import { Link } from 'react-router-dom';
import Logo from './Logo';
import { useLanguage } from '@/context/LanguageContext';

export const Footer = () => {
  const { t, language } = useLanguage();
  
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <Logo variant="light" />
            <p className="text-gray-400 mt-4 max-w-sm">
              {language === 'ES' 
                ? 'Convierte tus listados de propiedades en paquetes completos de marketing en minutos. Creado para agentes de bienes raíces que quieren ahorrar tiempo y cerrar más negocios.'
                : 'Turn your property listings into full marketing packages in minutes. Built for real estate agents who want to save time and close more deals.'
              }
            </p>
          </div>
          
          <div>
            <h4 className="font-heading font-semibold mb-4 text-white">{t('footer_product')}</h4>
            <ul className="space-y-3 text-gray-400">
              <li>
                <Link to="/pricing" className="hover:text-white transition-colors">
                  {t('nav_pricing')}
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-white transition-colors">
                  {t('nav_faq')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  {t('nav_contact')}
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-heading font-semibold mb-4 text-white">{t('footer_legal')}</h4>
            <ul className="space-y-3 text-gray-400">
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors">
                  {t('footer_privacy')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white transition-colors">
                  {t('footer_terms')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} ListingPro AI. {t('footer_copyright')}
          </p>
          <p className="text-gray-500 text-sm">
            {language === 'ES' 
              ? 'Hecho con IA para profesionales de bienes raíces'
              : 'Made with AI for real estate professionals'
            }
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
